import React, { useEffect, useState } from "react";
import { Select } from "../../tailwind/molecules/Select";
import MailerPanel from "./MailerPanel";
import { Heading, Spinner } from "../../common/atoms";
import { companyMailerApi } from "../../../services";
import { handleAppError } from "../../handlers";

const BenefitAdoptionMailerDashboard = () => {
  const [pageloading, setPageLoading] = useState(true);
  const [benefitsMailers, setBenefitsMailers] = useState([]);
  const [selectedBenefitId, setSelectedBenefitId] = useState(null);
  const [selectedBenefit, setSelectedBenefit] = useState(null);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    fetchMailers();
    setPageLoading(false);
  }, []);

  const fetchMailers = async () => {
    companyMailerApi.benefit_adoption_mailers(
      {},
      (res) => {
        let mailers = res.data?.mailer || [];
        setBenefitsMailers(mailers || []);
        setSelectedBenefitId(mailers[0]?.id || null);
        setSelectedBenefit(mailers[0] || null);
        setOptions(mailers.map((benefit) => ({
          label: `${benefit.benefit_name}`,
          value: benefit.id
        })));
      },
      (err) => {
        handleAppError(err);
      }
    );
  };

  const selectBenefit = (value) => {
    const selected = benefitsMailers.find((benefit) => benefit.id === value);
    setSelectedBenefitId(value);
    setSelectedBenefit(selected || null);
  };

  const pageReload = (value) =>  setPageLoading(value);

  return (
    <Spinner visible={pageloading}>
      <Heading mainHeading="Benefit Adoption Mailers" classes='mt-2'/>
      <p className='text-sm font-normal'>This section displays personalized benefit mailers, segmented by grade where applicable, to boost engagement and adoption.</p>

      <div className="container mx-auto px-4">
        <div className="mb-8 bg-white rounded-lg shadow-sm">
          <div className="p-5">
            <div className="flex flex-col gap-3">
              <div className="max-w-xs mx-auto">
                <Select
                  value={selectedBenefitId || ""}
                  onChange={selectBenefit}
                  options={options}
                  classes="bg-gray-100 w-44"
                  placeholder="Select benefit"
                />
              </div>
              {selectedBenefit && (
                <div className="mt-2 p-4 bg-primary/5 border border-primary/10 rounded-2xl shadow-sm">
                  <p className="text-gray-800 text-base leading-relaxed">
                    {selectedBenefit.description}
                  </p>
              </div>              
              )}
            </div>
          </div>
        </div>

        <MailerPanel selectedBenefit={selectedBenefit} fetchMailers={fetchMailers} setPageLoading={pageReload} pageloading={pageloading} />
      </div>
    </Spinner>
  );
};

export default BenefitAdoptionMailerDashboard;